"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Pound` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Pound = createSVGIcon(
  <>
    <path
      d="M.5 12.5a12 12 0 1 0 24 0 12 12 0 0 0-24 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.544 12.13c0 .289.234.523.523.523h.861c.203.76.388 1.468.388 2.21 0 .423-.084.76-.202 1.047-.852.16-1.351.782-1.585 1.4-.128.342.16.66.525.66.315 0 .561-.258.748-.512.17-.23.458-.4.902-.4.963 0 2.262 1.063 3.747 1.063 1.356 0 2.22-.826 2.505-2.036.081-.345-.206-.647-.56-.647-.325 0-.577.258-.676.567-.209.656-.72.884-1.437.884-.726 0-1.79-.641-2.903-.911.135-.32.22-.692.22-1.097 0-.844-.12-1.553-.254-2.228h2.835a.523.523 0 0 0 0-1.046H11.11c-.152-.71-.287-1.452-.287-2.363 0-1.384.928-2.296 2.227-2.296 1.166 0 1.747.49 2.046 1.394.112.339.408.598.765.598.432 0 .78-.373.665-.789C16.118 6.677 14.9 5.75 13.05 5.75c-2.092 0-3.713 1.418-3.713 3.477 0 .894.135 1.67.304 2.38h-.574a.523.523 0 0 0-.523.523"
      fill="currentColor"
    />
  </>,
  "Pound",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
